export function whatsappUrlForSharingAdvertising(whatsapp, titulo) {
  if (whatsapp) {
    const whatsappUrl = new URL(`https://wa.me/55${whatsapp}`);
    whatsappUrl.searchParams.set(
      "text",
      `Olá, vi seu anúncio no CLASSI! Quero saber mais sobre o anúncio ${titulo}.`,
    );
    return whatsappUrl;
  }
  return undefined;
}
